import { Navigate, useLocation } from 'react-router-dom';
import { adminAuthService } from '../services/adminAuth';

interface AdminBootstrapRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for admin bootstrap authentication.
 *
 * This allows access to admin pages when:
 * 1. User is authenticated via admin bootstrap (username/password)
 * 2. Password has been changed (password_must_change is false)
 *
 * This is separate from SSO authentication and is used for initial
 * application setup before SSO is configured.
 */
export function AdminBootstrapRoute({ children }: AdminBootstrapRouteProps) {
  const location = useLocation();

  // Check if authenticated via admin bootstrap
  if (!adminAuthService.isAuthenticated()) {
    return <Navigate to="/admin-setup" state={{ from: location }} replace />;
  }

  // Check if password change is required
  if (adminAuthService.mustChangePassword()) {
    return <Navigate to="/admin-setup/change-password" replace />;
  }

  return <>{children}</>;
}
